import { render } from "./FireWorkComponent.vue?vue&type=template&id=332ae461&scoped=true"
import script from "./FireWorkComponent.vue?vue&type=script&lang=js"
export * from "./FireWorkComponent.vue?vue&type=script&lang=js"

import "./FireWorkComponent.vue?vue&type=style&index=0&id=332ae461&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332ae461"]])

export default __exports__